import axios from "axios";

export const patientsService = {
  getPatientsService: (params) =>
    axios.get("/patients", { auth: true, params: { ...params } }),
  getSinglePatientService: (id) => axios.get(`/patients/${id}`, { auth: true }),
  deletePatientService: (id) => axios.delete(`/patients/${id}`, { auth: true }),
  addPatientService: (body) => axios.post("/patients", body, { auth: true }),
  editPatientService: (id, body) =>
    axios.patch(`/patients/${id}`, body, { auth: true }),
  changeStatusPatientService: (id, body) =>
      axios.patch(`/patients/${id}/status`, body, {auth: true}),
};
